interface Events {
  [key: string]: Function[];
}

export class Emitter {
  private events: Events = {};

  constructor() {
    this.init();
  }

  public subscribe(name: string, cb: Function) {
    (this.events[name] || (this.events[name] = [])).push(cb);
    return {
      unsubscribe: () =>
        this.events[name] &&
        this.events[name].splice(this.events[name].indexOf(cb) >>> 0, 1),
    };
  }

  public init() {
    this.events = {};
  }

  public emit(name: string, ...args: any[]): void {
    (this.events[name] || []).forEach((fn) => fn(...args));
  }
}
